"use strict";
/* eslint-disable no-bitwise, no-param-reassign */
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashString = void 0;
var hashString = function (stringToHash) {
    return Array.from(stringToHash)
        .reduce(function (acc, char, i) {
        var charCode = stringToHash.charCodeAt(i);
        acc = (acc << 5) - acc + charCode;
        acc &= acc;
        return acc;
    }, 0)
        .toString();
};
exports.hashString = hashString;
//# sourceMappingURL=hashString.js.map